import { FundAttributes } from "~/models/fund";
import { parseFundOverrides } from "~/utils/fund";
import { useFund } from "~/hooks/useFund";
import { ErrorMessage } from "~/common/list/ErrorMessage";
import Spinner from "~/common/icons/Spinner";
import { FundCardsView } from "./FundCardsView";
import { FundDonateButton } from "./FundDonateButton";
import { FundListView } from "./FundListView";

export function FundView(props: FundAttributes) {
  const [nonprofits, isError] = useFund(
    props.fundId,
    props.showFundDetails,
    props.randomize,
  );

  const fundOverrides = parseFundOverrides(props.fundOverrides);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log("FundView: opening donate modal");
    window.cnDonateFundModal(props.fundId, props.fundName);
    e.stopPropagation();
  };

  if (!nonprofits && props.showFundDetails) {
    return (
      <span className="tw:flex tw:flex-row tw:justify-center tw:items-center">
        <Spinner />
      </span>
    );
  }

  if (!props.showFundDetails) {
    return (
      // only show the donate button
      <FundDonateButton onClick={handleClick} />
    );
  }

  if (isError) {
    return <ErrorMessage message={`Error loading fund ${props.fundName}`} />;
  }

  return (
    <div className="cn-container-class">
      {props.listView ? (
        <FundListView
          title={props.title}
          nonprofits={nonprofits}
          fundOverrides={fundOverrides}
          onClick={handleClick}
        />
      ) : (
        <FundCardsView
          title={props.title}
          bannerImage={props.bannerImage}
          nonprofits={nonprofits}
          onClick={handleClick}
        />
      )}
    </div>
  );
}
